WB.Pollers = WB.Pollers ||{};

WB.Pollers.WeatherPoller = function($q, $log, Events, PageVisibilityUtility) {

    function WeatherPoller(options) {
        Events.call(this);
        this.type = options.type;
        this.time = options.time;
        this.manager = options.manager;
        this.$interval = options.$interval;
        this.pageVisibilityWorkHandler = PageVisibilityUtility.createWorkHandler();

        this.pageVisibilityWorkHandler.whenVisibleAgain(function() {
            this.poll();
        }.bind(this));

        $log.debug('[%s] poller registered. Polling in [%is].', this.type, this.time);
    }

    WeatherPoller.prototype = Object.create(Events.prototype);
    WeatherPoller.prototype.constructor = WeatherPoller;

    WeatherPoller.prototype.deregister = function() {
        $log.info('[%s] poller deregistered.', this.type);
        this.manager.DeregisterPoller(this);
        this.pageVisibilityWorkHandler.destroy();
    };

    WeatherPoller.prototype.poll = function() {
        this.pageVisibilityWorkHandler.ifVisible(function() {
            $log.debug('[%s] polled. Next poll in [%is].', this.type, this.time);
            this.fire('poll', function(fn) { fn(); });
        }.bind(this));
        this.pageVisibilityWorkHandler.ifNotVisible(function() {
            $log.debug('[%s] NOT polled due to page visibility being hidden. Next poll will be on page visibility.', this.type);
        }.bind(this));
    };

    return WeatherPoller;

};
WB.Pollers.WeatherPoller.$inject = ['$q', '$log', 'Events', 'PageVisibilityUtility'];
WB.App.service('WeatherPoller', WB.Pollers.WeatherPoller);